import { businessKey } from 'queryKeys';

const PARTNER_AUDIENCE = 'pa';

const MUTATION_BATCH_SYNC = 'batchSyncPA';
const MUTATION_BATCH_DELETE = 'batchDeletePA';
const MUTATION_SYNC = 'syncPA';
const MUTATION_AUTOSYNC = 'autoSyncPA';
const MUTATION_SHARED_ACCOUNTS = 'createSharedAccounts';
const MUTATION_SET_RECEIVE_NOTIFICATION = 'setReceiveNotification';

const paQuery = businessKey.query(PARTNER_AUDIENCE);

export const grid = paQuery.grid();
export const grids = paQuery.grids();

export const model = paQuery.exact();
export const details = paQuery.details();

export const sharedAccountsPA = paQuery.exact('SA');
export const lookaLikePA = paQuery.exact('LL');

export const mutations = paQuery.mutations();

export const exportGridPA = mutations.mutate('export');
export const create = mutations.create();
export const update = mutations.update();
export const remove = mutations.delete();
export const archive = mutations.archive();
export const restore = mutations.restore();

export const batchSyncPA = mutations.mutate(MUTATION_BATCH_SYNC);
export const batchDeletePA = mutations.mutate(MUTATION_BATCH_DELETE);
export const syncPA = mutations.mutate(MUTATION_SYNC);
export const autoSyncPA = mutations.mutate(MUTATION_AUTOSYNC);
export const createSharedAccounts = mutations.mutate(MUTATION_SHARED_ACCOUNTS);
export const setReceiveNotification = mutations.mutate(
  MUTATION_SET_RECEIVE_NOTIFICATION
);
